import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex w-full flex-col gap-2 font-catering-body" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "text-catering-tomato-500"
}
const _hoisted_4 = {
  key: 0,
  class: "inline-flex text-catering-ink-400"
}
const _hoisted_5 = {
  key: 1,
  class: "whitespace-nowrap text-catering-ink-500"
}
const _hoisted_6 = ["id", "type", "value", "name", "autocomplete"]
const _hoisted_7 = {
  key: 2,
  class: "whitespace-nowrap text-catering-ink-500"
}

import { ulid } from 'ulid'
import { ref } from 'vue'

export default /*@__PURE__*/Object.assign({ inheritAttrs: false }, {
  __name: 'CateringField',
  props: {
  modelValue: { type: String, default: '' },
  label: String,
  hint: String,
  error: String,
  prefix: String,
  suffix: String,
  required: { type: Boolean, default: false },
  restrict: String,
  type: { type: String, default: 'text' }
},
  emits: ['update:modelValue', 'blur'],
  setup(__props, { expose: __expose, emit: __emit }) {


const id = ulid()
const focused = ref(false)
const input = ref(null)
__expose({ input })
const props = __props
const emit = __emit
const onBlur = () => {
  focused.value = false
  emit('blur')
}
const onInput = e => {
  let v = e.target.value
  if (props.restrict === 'url') v = v.replace(/^\s*https?:\/\//i, '').replace(/^\/+/, '')
  if (props.restrict === 'integer') v = v.replace(/\D/g, '')
  if (props.restrict === 'float') v = v.replace(/[^0-9.]/g, '').replace(/(?<=\..*)\./g, '')
  if (props.restrict === 'monetary')
    v = v
      .replace(/[^0-9.]/g, '')
      .replace(/(?<=\..*)\./g, '')
      .replace(/(\.\d{2})\d+/, '$1')
  e.target.value = v
  emit('update:modelValue', v)
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _unref(id),
          class: "flex gap-1 text-sm font-semibold text-catering-ink-900"
        }, [
          _createTextVNode(_toDisplayString(__props.label) + " ", 1),
          (__props.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
            : _createCommentVNode("", true)
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["flex h-12 items-center gap-2 rounded-catering-sm border-[1.5px] bg-catering-cream-50 px-4 transition-all duration-150", 
        __props.error
          ? 'border-catering-berry-500 shadow-[0_0_0_3px_rgba(194,69,58,0.18)]'
          : focused.value
            ? 'border-catering-ink-900 shadow-catering-focus'
            : 'border-catering-cream-500 shadow-catering-inset'
      ])
    }, [
      (_ctx.$slots.leftIcon)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
            _renderSlot(_ctx.$slots, "leftIcon")
          ]))
        : _createCommentVNode("", true),
      (__props.prefix)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.prefix), 1))
        : _createCommentVNode("", true),
      _createElementVNode("input", _mergeProps({
        id: _unref(id),
        ref_key: "input",
        ref: input
      }, _ctx.$attrs, {
        type: __props.type,
        value: __props.modelValue,
        name: `f-${_unref(id)}`,
        autocomplete: `nope-${_unref(id)}`,
        "data-1p-ignore": "",
        "data-lpignore": "true",
        "data-bwignore": "",
        "data-form-type": "other",
        class: "h-full min-w-0 flex-1 border-none bg-transparent text-catering-base text-catering-ink-900 outline-none focus:ring-0 placeholder:text-catering-ink-400",
        onInput: onInput,
        onFocus: _cache[0] || (_cache[0] = $event => (focused.value = true)),
        onBlur: onBlur
      }), null, 16, _hoisted_6),
      (__props.suffix)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(__props.suffix), 1))
        : _createCommentVNode("", true)
    ], 2),
    (__props.error || __props.hint)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass(["text-xs", __props.error ? 'text-catering-berry-600' : 'text-catering-ink-500'])
        }, _toDisplayString(__props.error || __props.hint), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})